import React, { FC } from 'react';

import { Box, Heading, Text } from '@lucid/components-react';
import ReactHtmlParser from 'react-html-parser';
import { Drupal_ParagraphFlexiSection } from 'generated/drupal-graphql';
import { getProcessedValue } from '@lucid/utils';
import { LucidTheme } from '@lucid/theme';

interface AttributionProps {
  entity: Drupal_ParagraphFlexiSection;
}

const Attribution: FC<AttributionProps> = ({ entity }) => {
  return (
    <Box
      alignItems="center"
      css={{ label: 'flexiStyledSectionAttribution' }}
      display="flex"
      flexWrap="wrap"
      gridColumn="1 / -1"
      mb={11}
      position="relative"
      px={{ default: 0, tablet: 6 }}
    >
      <Box
        css={(theme: LucidTheme) => ({
          '&::after': {
            content: '""',
            position: 'absolute',
            top: theme.space[3],
            left: theme.space[3],
            width: '100%',
            height: '100%',
            borderBottom: `3px solid ${theme.colors.primary}`,
            borderRight: `3px solid ${theme.colors.primary}`
          }
        })}
        flex={{
          default: '0 1 100%',
          tablet: '0 1 50%'
        }}
        left={{ default: 0, tablet: 4 }}
        mb={{ default: 5, tablet: 0 }}
        position="relative"
      >
        <img
          alt={entity.fieldFlexiHeader || ''}
          css={(theme: LucidTheme) => ({
            boxShadow: `-10px -10px 0px 10px ${theme.colors.primary}`
          })}
          loading="lazy"
          src={entity.fieldFlexiImage || ''}
        />
      </Box>
      <Box
        css={(theme: LucidTheme) => ({
          backgroundColor: theme.colors.coolGrey[5],
          zIndex: theme.zIndices[2]
        })}
        flex={{
          default: '0 1 100%',
          tablet: '0 1 50%'
        }}
        p={6}
      >
        <Text as="div" variant="COquoteXS300">
          {ReactHtmlParser(getProcessedValue(entity.fieldFlexiBody))}
        </Text>
        <Heading variant="COsubheadXXS700">{entity.fieldFlexiHeader}</Heading>
      </Box>
    </Box>
  );
};

export default Attribution;
